import { showMapPopupTemplate } from "../../utils/popupTemplate";
/**@category utilities */
export function showMapPopup(popupSettings) {
    showMapPopupTemplate(popupSettings);
}
